<template>
  <v-card height='100%'>
    <v-card-subtitle>
      {{ $vuetify.lang.t('$vuetify.map.demoVideo.stateSelector.title') }}
    </v-card-subtitle>
    <v-card-text>
      <v-select v-model="values" :placeholder="$vuetify.lang.t('$vuetify.map.demoVideo.stateSelector.allSelected')"
                :items="items"
                multiple chips deletable-chips></v-select>
    </v-card-text>
  </v-card>
</template>

<script>
import Vuetify from '../../../plugins/vuetify'
import { usedDangerousStates } from '../../../utils/filters'

export default {
  name: 'stateSelector',
  data: () => ({
    values: []
  }),
  computed: {
    items () {
      return Object.values(usedDangerousStates()).map(item => ({
        value: item,
        text: Vuetify.framework.lang.t(`$vuetify.map.criticalPopup.title.${item}`)
      }))
    }
  },
  watch: {
    values (value) {
      this.$emit('state-changed', value)
    }
  }
}
</script>

<style scoped>

</style>
